import { EmployeeProxy } from "@me-team/host/main/graphql/types";
import { joyrideService } from "../Joyride/joyrideService";

export const getRowClassName = (
    employee: EmployeeProxy,
    currentUser?: { id: number; name: string },
    index?: number,
    addClass?: string
) => {
    if (currentUser?.id) return employee.id === currentUser.id ? addClass : "";
    return index === 0 ? addClass : "";
};

export const setJoyrideUser = (
    joyrideServiceUser: { id: number; name?: string } | null,
    run: boolean,
    currentBranchEmployeeId: number
): { id: number; name?: string } | null => {
    if (run && joyrideServiceUser) {
        joyrideService.setUser(joyrideServiceUser);
        return joyrideServiceUser;
    }

    if (run && currentBranchEmployeeId) {
        const newUser = { id: currentBranchEmployeeId };
        joyrideService.setUser(newUser);
        return newUser;
    }

    joyrideService.clearUser();
    return null;
};
